import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Filter, X } from 'lucide-react';
import { ProductCard } from '../components/ProductCard';
import { products, ProductCategory, Season } from '../data/products';
export function Shop() {
  const [activeCategory, setActiveCategory] = useState<ProductCategory | 'All'>('All');
  const [activeSeason, setActiveSeason] = useState<Season | 'All'>('All');
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const categories: (ProductCategory | 'All')[] = ['All', 'Complete Systems', 'Bundles', 'Modules', 'Accessories'];
  const seasons: (Season | 'All')[] = ['All', 'Lawn Care', 'Snow Removal', 'Leaf Cleanup', 'All-Season'];
  const filteredProducts = products.filter(p => {
    const categoryMatch = activeCategory === 'All' || p.category === activeCategory;
    const seasonMatch = activeSeason === 'All' || p.season.includes(activeSeason as Season) || p.season.includes('All-Season');
    return categoryMatch && seasonMatch;
  });
  return <div className="bg-gray-50 min-h-screen py-12" data-id="element-626">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-627">
        <div className="mb-8 md:mb-12" data-id="element-628">
          <h1 className="text-4xl font-extrabold text-yarbo-dark mb-4" data-id="element-629">
            Shop Yarbo Robotic Yard Care Systems
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl" data-id="element-630">
            Explore our complete lineup of Yarbo systems, bundles, and modules.
            Build the perfect automated yard care setup for your Michigan
            property.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8" data-id="element-631">
          {/* Mobile Filter Toggle */}
          <div className="md:hidden" data-id="element-632">
            <button onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)} className="w-full btn-secondary flex items-center justify-between" data-id="element-633">
              <span className="flex items-center" data-id="element-634">
                <Filter className="w-5 h-5 mr-2" data-id="element-635" /> Filters
              </span>
              {isMobileFilterOpen ? <X className="w-5 h-5" data-id="element-636" /> : null}
            </button>
          </div>

          {/* Sidebar Filters */}
          <div className={`md:w-64 flex-shrink-0 ${isMobileFilterOpen ? 'block' : 'hidden md:block'}`} data-id="element-637">
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm sticky top-24" data-id="element-638">
              <div className="mb-8" data-id="element-639">
                <h3 className="font-bold text-yarbo-dark mb-4 uppercase tracking-wider text-sm" data-id="element-640">
                  Product Type
                </h3>
                <div className="space-y-2" data-id="element-641">
                  {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`block w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${activeCategory === cat ? 'bg-yarbo-yellow/20 text-yarbo-dark font-bold' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-642">
                      {cat}
                    </button>)}
                </div>
              </div>

              <div data-id="element-643">
                <h3 className="font-bold text-yarbo-dark mb-4 uppercase tracking-wider text-sm" data-id="element-644">
                  Season
                </h3>
                <div className="space-y-2" data-id="element-645">
                  {seasons.map(season => <button key={season} onClick={() => setActiveSeason(season)} className={`block w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${activeSeason === season ? 'bg-yarbo-yellow/20 text-yarbo-dark font-bold' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-646">
                      {season}
                    </button>)}
                </div>
              </div>
            </div>
          </div>

          {/* Product Grid */}
          <div className="flex-grow" data-id="element-647">
            <div className="mb-6 flex justify-between items-center" data-id="element-648">
              <span className="text-gray-500 text-sm font-medium" data-id="element-649">
                Showing {filteredProducts.length} products
              </span>
            </div>

            {filteredProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-650">
                {filteredProducts.map((product, idx) => <motion.div key={product.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.3,
              delay: idx * 0.05
            }} data-id="element-651">
                    <ProductCard product={product} data-id="element-652" />
                  </motion.div>)}
              </div> : <div className="bg-white p-12 rounded-xl border border-gray-200 text-center" data-id="element-653">
                <h3 className="text-xl font-bold text-yarbo-dark mb-2" data-id="element-654">
                  No products found
                </h3>
                <p className="text-gray-500 mb-6" data-id="element-655">
                  Try adjusting your filters to see more results.
                </p>
                <button onClick={() => {
              setActiveCategory('All');
              setActiveSeason('All');
            }} className="btn-secondary" data-id="element-656">
                  Clear Filters
                </button>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}